import script from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./CookieConsentBanner.vue?vue&type=script&setup=true&lang=ts"

import "./CookieConsentBanner.vue?vue&type=style&index=0&id=ea07288e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ea07288e"]])

export default __exports__